import styled from "styled-components";
import { breakpoints } from "../../globalStyles";

export const ControlButton = styled.button`
  cursor: pointer;
  padding: 0;
  display: flex;
  width: 48px;
  height: 48px;
  justify-content: center;
  align-items: center;

  & svg {
    transform: scale(100%);
    transition: transform 100ms ease-out;
  }
  &:hover {
    & svg {
      transform: scale(125%);
    }
  }
  &:active {
    & svg {
      transform: scale(100%);
    }
  }
  & svg {
    width: 24px;
    height: 24px;
  }

  @media ${breakpoints.sm} {
    display: none;
  }
`;
